import React from 'react';
import { menuItems } from '../../constants/navData';
import { Link } from 'gatsby';
import {
	NavigationMenu,
	NavigationMenuContent,
	NavigationMenuItem,
	NavigationMenuLink,
	NavigationMenuList,
	NavigationMenuTrigger,
} from '../ui/navigation-menu';
import { cn } from '../../lib/utils';

export default function DesktopMenu({ currentLocation }) {
	return (
		<nav className='hidden md:block'>
			<NavigationMenu viewport={false}>
				<NavigationMenuList className='gap-2'>
					{menuItems.map((item) =>
						item.hasDropdown ? (
							<NavigationMenuItem key={item.title} className='relative'>
								<NavigationMenuTrigger className='bg-transparent text-black text-lg font-normal tracking-wider hover:bg-transparent hover:text-[#6CB132] data-[state=open]:bg-transparent data-[state=open]:text-[#6CB132]'>
									{item.title}
								</NavigationMenuTrigger>
								<NavigationMenuContent className='absolute left-0 top-full mt-1.5 w-[180px] rounded-md border bg-white shadow-lg z-[100] data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95'>
									<ul className='grid gap-1 p-2'>
										{item.children.map((child) => (
											<li key={child.path}>
												<NavigationMenuLink asChild>
													<Link
														to={child.path}
														className={cn(
															'block select-none rounded-md px-3 py-2 text-sm leading-none no-underline outline-none transition-colors hover:bg-[#6CB132] hover:text-white focus:bg-[#6CB132] focus:text-white',
															child.path === currentLocation
																? 'bg-[#6CB132] text-white'
																: 'text-gray-700'
														)}
													>
														{child.title}
													</Link>
												</NavigationMenuLink>
											</li>
										))}
									</ul>
								</NavigationMenuContent>
							</NavigationMenuItem>
						) : (
							<NavigationMenuItem key={item.path}>
								<NavigationMenuLink asChild>
									<Link
										to={
											item.path.includes('#')
												? `/${item.path}`
												: item.path
										}
										className={cn(
											'inline-block text-lg font-normal tracking-wider py-1 px-4 hover:text-[#6CB132] transition-colors',
											item.path === currentLocation
												? 'text-[#6CB132]'
												: 'text-black'
										)}
									>
										{item.title}
									</Link>
								</NavigationMenuLink>
							</NavigationMenuItem>
						)
					)}
				</NavigationMenuList>
			</NavigationMenu>
		</nav>
	);
}
